/**
 * Venue Dashboard — operational metrics for a venue's L&F program.
 *
 * v1: placeholder shell. Full implementation pending — needs:
 *   - Items logged (today / week / month)
 *   - Match rate
 *   - Aging items (30/60/90 day buckets)
 *   - Return rate, time-to-match histograms
 *
 * For now, communicates "this is coming" without breaking the IA.
 */

export default function VenueDashboard() {
  return (
    <div className="flex-1 min-h-0 flex flex-col">
      <header className="shrink-0 pt-6 pb-2 text-center">
        <p className="text-[10px] font-medium tracking-[0.18em] uppercase" style={{ color: 'var(--text-ghost)' }}>
          The Lost Club · Venue
        </p>
        <h1 className="mt-2 text-xl font-semibold" style={{ color: 'var(--text-primary)' }}>
          Dashboard
        </h1>
      </header>

      <div className="flex-1 min-h-0 flex flex-col items-center justify-center px-6">
        <div className="text-center max-w-sm">
          <div
            className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-4"
            style={{ background: 'var(--accent-muted)', color: 'var(--accent)' }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="20" x2="18" y2="10" />
              <line x1="12" y1="20" x2="12" y2="4" />
              <line x1="6" y1="20" x2="6" y2="14" />
            </svg>
          </div>
          <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
            Operations dashboard
          </h2>
          <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
            Coming soon. Items logged, match rate, aging inventory, return time — at a glance.
          </p>
        </div>
      </div>
    </div>
  )
}
